var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { createEffect, createEvent, createStore, sample } from "effector";
import { resetPlayerCurrentTrackIndexAndTrackSourceIndex, resetPlayerTrackQueue, setPlayerTrackQueue, } from "frontend/src/domain/player-track-queue";
import { getWebSchedulePlayer } from "frontend/src/api/web-schedules";
import { play, resetAudio } from "frontend/src/features/control-audio";
import { notify } from "frontend/src/features/notifications";
import { clearTimetableInterruptions, resetTimetableInterruption, setTimetableInterruptions, } from "frontend/src/features/play-timetable-interruptions";
var refreshTimer = null;
var activePayload = null;
var clearRefreshTimer = function () {
    if (refreshTimer !== null) {
        window.clearTimeout(refreshTimer);
        refreshTimer = null;
    }
};
var timeToSeconds = function (time) {
    var _a = time.split(":").map(Number), hours = _a[0], minutes = _a[1], seconds = _a[2];
    return hours * 3600 + minutes * 60 + (seconds || 0);
};
var currentDayBit = function () {
    var day = new Date().getDay();
    return 1 << ((day + 6) % 7);
};
var secondsSinceMidnight = function () {
    var date = new Date();
    return date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();
};
var shuffleTracks = function (items) {
    return __spreadArray([], items).sort(function () { return Math.random() - 0.5; });
};
var buildInterruptions = function (advertisements) {
    var day = currentDayBit();
    var now = secondsSinceMidnight();
    return advertisements.flatMap(function (advertisement) {
        if (!advertisement.track || !advertisement.interruptPlaying) {
            return [];
        }
        if ((advertisement.daysEnabled & day) === 0) {
            return [];
        }
        var start = timeToSeconds(advertisement.timeStart);
        var end = timeToSeconds(advertisement.timeEnd);
        if (end <= now) {
            return [];
        }
        var interval = Math.max(1, advertisement.repeatIntervalMinutes || 0) * 60;
        var offsets = [];
        for (var point = start; point < end; point += interval) {
            if (point >= now) {
                offsets.push({
                    offsetSeconds: point - now,
                    track: advertisement.track,
                });
            }
        }
        return offsets;
    });
};
var getActiveWindows = function (musicWindows) {
    var day = currentDayBit();
    var now = secondsSinceMidnight();
    return musicWindows.filter(function (window) {
        if ((window.daysEnabled & day) === 0) {
            return false;
        }
        return (timeToSeconds(window.timeStart) <= now &&
            timeToSeconds(window.timeEnd) > now);
    });
};
var getCurrentTracks = function (musicWindows) {
    var activeWindows = getActiveWindows(musicWindows).map(function (window) { return (__assign(__assign({}, window), { tracks: (window.playOrder === "random" ? shuffleTracks(window.tracks) : window.tracks).map(function (track) { return (__assign(__assign({}, track), { webSchedulePlaylistTitle: window.playlistTitle })); }) })); });
    var result = [];
    var maxLength = Math.max.apply(Math, __spreadArray([0], activeWindows.map(function (window) { return window.tracks.length; })));
    var _loop_1 = function (index) {
        activeWindows.forEach(function (window) {
            if (window.tracks[index]) {
                result.push(window.tracks[index]);
            }
        });
    };
    for (var index = 0; index < maxLength; index++) {
        _loop_1(index);
    }
    return result;
};
var getNextRefreshDelay = function (musicWindows) {
    var day = currentDayBit();
    var now = secondsSinceMidnight();
    var points = musicWindows
        .filter(function (window) { return (window.daysEnabled & day) !== 0; })
        .flatMap(function (window) { return [
        timeToSeconds(window.timeStart),
        timeToSeconds(window.timeEnd),
    ]; })
        .filter(function (point) { return point > now; })
        .sort(function (a, b) { return a - b; });
    if (points.length === 0) {
        return null;
    }
    return Math.max(1000, (points[0] - now) * 1000 + 500);
};
var scheduleNextRefresh = function (musicWindows) {
    clearRefreshTimer();
    var delay = getNextRefreshDelay(musicWindows);
    if (delay === null || !activePayload) {
        return;
    }
    refreshTimer = window.setTimeout(function () {
        if (activePayload) {
            playWebScheduleFx(activePayload);
        }
    }, delay);
};
export var playWebScheduleAttempted = createEvent();
export var stopWebScheduleAttempted = createEvent();
export var deactivateWebSchedule = createEvent();
export var $activeWebSchedule = createStore(null)
    .on(playWebScheduleAttempted, function (_, schedule) { return schedule; })
    .reset(stopWebScheduleAttempted);
$activeWebSchedule.on(deactivateWebSchedule, function () { return null; });
deactivateWebSchedule.watch(function () {
    activePayload = null;
    clearRefreshTimer();
});
var playWebScheduleFx = createEffect(function (_a) {
    var id = _a.id, title = _a.title;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, tracks;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getWebSchedulePlayer(id)];
                case 1:
                    response = _b.sent();
                    tracks = getCurrentTracks(response.musicWindows);
                    return [2 /*return*/, {
                            title: title,
                            tracks: tracks,
                            interruptions: buildInterruptions(response.advertisements),
                            musicWindows: response.musicWindows,
                        }];
            }
        });
    });
});
playWebScheduleAttempted.watch(function (payload) {
    activePayload = payload;
    clearRefreshTimer();
});
sample({
    clock: playWebScheduleAttempted,
    target: playWebScheduleFx,
});
stopWebScheduleAttempted.watch(function () {
    activePayload = null;
    clearRefreshTimer();
    clearTimetableInterruptions();
    resetTimetableInterruption();
    resetAudio();
    resetPlayerCurrentTrackIndexAndTrackSourceIndex();
    resetPlayerTrackQueue();
});
playWebScheduleFx.done.watch(function (_a) {
    var params = _a.params, result = _a.result;
    scheduleNextRefresh(result.musicWindows);
    if (result.tracks.length === 0) {
        clearTimetableInterruptions();
        resetTimetableInterruption();
        resetAudio();
        resetPlayerCurrentTrackIndexAndTrackSourceIndex();
        resetPlayerTrackQueue();
        notify({
            variant: "error",
            message: "\u0412 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0438 \"" + result.title + "\" \u0441\u0435\u0439\u0447\u0430\u0441 \u043D\u0435\u0442 \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043C\u0443\u0437\u044B\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043E\u043A\u043E\u043D.",
        });
        return;
    }
    clearTimetableInterruptions();
    resetTimetableInterruption();
    setTimetableInterruptions(result.interruptions);
    setPlayerTrackQueue({
        type: "web_schedule",
        attributes: {
            id: params.id,
            title: params.title,
        },
        tracks: result.tracks,
    });
    resetPlayerCurrentTrackIndexAndTrackSourceIndex();
    play(result.tracks[0].url);
});
playWebScheduleFx.fail.watch(function (_a) {
    var params = _a.params, error = _a.error;
    stopWebScheduleAttempted();
    notify({
        variant: "error",
        message: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \"" + params.title + "\": " + String(error),
    });
});
